import {AUTH} from '~/config'
import {invalidateCache} from '~/services/cache/profileCache'
import {http} from '~/utils/http'

export function login(loginData: {email: string, password: string, rememberMe: boolean}) {
    return http.post(`${AUTH}/login`, loginData)
        .catch(({error}) => {
            throw error
        })
        .finally(() => invalidateCache({shouldDispatch: true}))
}

// TODO: очистить кеш профиля
export function logout() {
    return http.post(`${AUTH}/logout`)
        .finally(() => invalidateCache({shouldDispatch: true}))
}
